export const TOOLS_REPORT_KEYS = ["tool_opens", "unique_users", "tool_clicks", "tool_ad_opens_unique_users"];
export const TOOLS_SEARCH_ONLY_KEYS = ["id", "tool_id"];
